import Head from "next/head";
import Magazine from "../../../components/collection/magazine";
import { Breakpoint } from "../../../utils/media-query";

const SixMagazine = () => {
  const [isDesktop, isTablet, isMobile] = Breakpoint();

  return (
    <>
      <Head>
        <title>Six magazine | Aurum Lab</title>
        <meta
          name="description"
          content="Six Collection Aurum Lab, we give you a wider choice of Aurum Lab’s jewelry. Here’s a 6K gold collection for the most stand out look ever."
        />
      </Head>
      <main>
        <div className={isDesktop ? "container" : "container-mobile"}>
          <Magazine src="https://e.issuu.com/embed.html?backgroundColorFullscreen=%23ffffff&d=magazine_6k_gold_collection&doAutoflipPages=true&hideIssuuLogo=true&hideShareButton=true&showOtherPublicationsAsSuggestions=true&u=aurumlab" />
        </div>
      </main>
    </>
  );
};
export default SixMagazine;
